import {
  LibraryActions,
  type LibraryItem,
  type LibraryKind,
  type LibraryUpsertPayload,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { call, put, select } from 'redux-saga/effects'

import { listLibraryItems } from '@/services/library'
import type { LibrarySagaActions } from '../actions'
import { selectCanReadLibrary } from '../selectors'

/** The list of the workspace of the project — only for those who may see it. */
export function* fetchLibrary({
  payload: { kind },
}: ReturnType<typeof LibrarySagaActions.fetch>) {
  const canRead: boolean = yield select(selectCanReadLibrary)

  if (!canRead) {
    return
  }

  const workspaceId: string = yield select(
    migrationProjectSelector.getLibraryWorkspaceParam
  )

  try {
    const items: LibraryItem<LibraryKind>[] = yield call(
      listLibraryItems,
      workspaceId,
      kind
    )

    yield put(LibraryActions.upsert({ kind, items } as LibraryUpsertPayload))
    yield put(LibraryActions.setOwn({ kind, ids: items.map(({ id }) => id) }))
  } catch (error) {
    console.error('Failed to load the workspace library', error)
  }
}
